import React from 'react';
import { observer } from 'mobx-react';
import { MatField } from 'src/core/components/mat-field';
import { FieldState } from 'formstate';
import { Radio, FormControlLabel, RadioGroup } from '@material-ui/core';
import * as styles from './application.less';
import { MarriageForm } from '../../forms/application-information-forms';
import { spouseContactFormatter } from '../../forms/application-information-forms-utils';
interface IApplicantMaritalStatusProps {
    marriage: MarriageForm;
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}

export const ApplicantMaritalStatus: React.FC<IApplicantMaritalStatusProps> = observer(
    ({ marriage, validate }) => {
        return (
            <React.Fragment>
                <div className={styles.sectionTitle}>Single or Married *</div>
                <div className={styles.radioRow}>
                    <RadioGroup
                        row
                        value={marriage.$.isMarried.value ? '1' : '0'}
                        onChange={(e, val) => marriage.$.isMarried.onChange(val === '1')}
                    >
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="0"
                            control={<Radio className={styles.radio} />}
                            label="Single"
                            onClick={async (e) => {
                                marriage.$.ContactInfo.reset();
                                await validate(marriage.$.ContactInfo)();
                            }}
                        />
                        <FormControlLabel
                            className={styles.radioLabel}
                            value="1"
                            control={<Radio className={styles.radio} />}
                            label="Married"
                            onClick={async (e) => {
                                await validate(marriage.$.ContactInfo)();
                            }}
                        />
                    </RadioGroup>
                </div>
                {marriage.$.isMarried.value && (
                    <div className={styles.nextRadioRow}>
                        <MatField
                            required
                            errorColor
                            fieldState={marriage.$.ContactInfo}
                            maxLength={100}
                            formatter={spouseContactFormatter}
                            label="Spouse Contact Info"
                            onBlur={validate(marriage.$.ContactInfo)}
                        />
                    </div>
                )}
            </React.Fragment>
        );
    }
);
